// extracted by mini-css-extract-plugin
module.exports = {"header":"EventTitle_header__2ywPt","prefix":"EventTitle_prefix__1jVm6","title":"EventTitle_title__2flPO"};